export default __webpack_public_path__ + "static/banner4-a6d70003608449802fb80f89bdb06cdf.png";